import { render } from "./FadingBigHeadline.vue?vue&type=template&id=f8cfe2a4&scoped=true"
import script from "./FadingBigHeadline.vue?vue&type=script&lang=js"
export * from "./FadingBigHeadline.vue?vue&type=script&lang=js"

import "./FadingBigHeadline.vue?vue&type=style&index=0&id=f8cfe2a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8cfe2a4"]])

export default __exports__